export default "__VITE_ASSET__Bdu6kQtf__"